require("./syncWithServer")

module.exports = {}